import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { useContext } from 'react';
import { FormVolatileContext } from './react-forms';

function Form(props) {
  var _useContext = useContext(FormVolatileContext),
      submitForm = _useContext.submitForm;

  return /*#__PURE__*/React.createElement("form", _extends({
    onSubmit: submitForm
  }, props));
}

export default Form;